import type { OrderItem } from '../types';

/** Total panier (prix unitaire × quantité) — même formule que CartContext.totalAmount. */
export function computeCartTotal(items: OrderItem[]): number {
  return items.reduce((total, item) => total + item.prix_unitaire * item.quantite, 0);
}
